/* global $, $$ */ /* Bliss */

export class LiveFilter {
  constructor(form) {
    this.form = form
    this.container = $(form.dataset.livefilter)
    this.items = Array.from(this.container.children)
    this.by = form.dataset.livefilterBy
      .split(',')
      .map(name => ({name: name, selector: `input[name=${name}]`}))
    this.empty = $('[data-empty]', this.container)

    if (window.location.hash) {
      this._restoreSelection()
    }

    this.by.forEach(({selector}) => {
      $$(selector, this.form)._.addEventListener('change', () =>
        this.showHide()
      )
    })

    // Run once.
    this.showHide()
  }

  showHide() {
    let values = this._getSelection(),
      visible = 0
    this._saveSelection(values)

    this.items.forEach(item => {
      let show = true
      this.by.forEach(({name}) => {
        if (
          values[name].length &&
          values[name].indexOf(item.dataset[name]) === -1
        )
          show = false
      })
      item.classList[show ? 'remove' : 'add']('hidden')
      if (show) ++visible
    })

    if (this.empty) this.empty.style.display = visible > 0 ? 'none' : 'block'
  }

  _getSelection() {
    let values = {}
    this.by.forEach(({name, selector}) => {
      values[name] = $$(`${selector}:checked`, this.form).reduce((a, b) => {
        b.value && a.push(b.value)
        return a
      }, [])
    })
    return values
  }

  _saveSelection(values) {
    let hash = []
    // for (let [key, value] of Object.entries(values)), but that's ES7 only...
    for (let name of Object.keys(values)) {
      hash.push(`${name}=${values[name]}`)
    }
    window.location.replace('#' + hash.join('&'))
  }

  _restoreSelection() {
    let values = this._parseHash(window.location.hash)
    this.by.forEach(({name, selector}) => {
      if (values[name] && values[name].length) {
        $$(selector, this.form).forEach(input => {
          input.checked = values[name].indexOf(input.value) !== -1
        })
      }
    })
  }

  _parseHash(hash) {
    let values = {}
    hash = hash.replace(/^#/, '')
    hash.split('&').forEach(part => {
      let [name, vals] = part.split('=')
      if (vals) values[name] = vals.split(',')
    })
    return values
  }
}
